// removed by extract-text-webpack-plugin
module.exports = {"flexWrapper":"AuditTemplateBlockOverview__flexWrapper__SFppE"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateBlockOverview/AuditTemplateBlockOverview.scss
// module id = 1623
// module chunks = 0